module.exports = __webpack_public_path__ + "static/media/emoji1.7df01aee.png";